/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import type { User } from '@modules/cloud-api/v1/types'
import type { AsyncRequestState } from '@modules/ui-types'
import Feature from '@modules/utils/feature'

import { getCurrentUser } from '@/reducers/currentUser'
import { fetchCurrentUserRequest } from '@/reducers/asyncRequests/registry'

import { getConfig, getConfigForKey, isFeatureActivated } from '../../../../selectors'
import { createDeploymentUrl, deploymentGettingStartedUrl } from '../../../../lib/urlBuilder'

import App from './App'

import type { AppConfig } from '../../../../../config/types'
import type { RouteComponentProps } from 'react-router'

interface StateProps {
  pollingInterval: number
  config: AppConfig
  currentUser: User | null
  requireEula: boolean
  fetchCurrentUserRequest: AsyncRequestState
  isCreateUrl: boolean
  isGettingStartedUrl: boolean
}

type ConsumerProps = RouteComponentProps

const mapStateToProps = (state, { location, match: { params } }): StateProps => {
  const { deploymentId } = params

  return {
    requireEula: isFeatureActivated(state, Feature.eula),
    config: getConfig(state),
    currentUser: getCurrentUser(state),
    pollingInterval: getConfigForKey(state, `POLLING_INTERVAL`),
    fetchCurrentUserRequest: fetchCurrentUserRequest(state),
    isCreateUrl: location.pathname === createDeploymentUrl(),
    isGettingStartedUrl: location.pathname === deploymentGettingStartedUrl(deploymentId),
  }
}

export default withRouter(connect<StateProps, null, ConsumerProps>(mapStateToProps)(App))
